import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-185f188e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content page-watermark-host" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "vertical-market-dimension-tabs vertical-market-total-tabs" }
const _hoisted_6 = { class: "total-data-wrap" }
const _hoisted_7 = { class: "total-data-group-title total-data-group-title--daily" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "star" }, "*", -1))
const _hoisted_9 = {
  key: 0,
  class: "total-data-group-title__note"
}
const _hoisted_10 = { class: "total-summary-table" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "total-sum-td-name" }
const _hoisted_13 = {
  colspan: "2",
  class: "total-sum-td-value total-sum-td-value--wide"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "total-sum-td-name" }
const _hoisted_16 = { class: "total-sum-td-value" }
const _hoisted_17 = { class: "total-sum-td-mom" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "环比：", -1))
const _hoisted_19 = {
  key: 0,
  class: "total-empty-mark"
}
const _hoisted_20 = { class: "total-summary-table" }
const _hoisted_21 = { class: "total-sum-td-name" }
const _hoisted_22 = { class: "total-sum-td-value" }
const _hoisted_23 = { class: "total-sum-td-mom" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "环比：", -1))
const _hoisted_25 = {
  key: 0,
  class: "total-empty-mark"
}
const _hoisted_26 = { class: "total-summary-table" }
const _hoisted_27 = { class: "total-sum-td-name" }
const _hoisted_28 = { class: "total-sum-td-value" }
const _hoisted_29 = { class: "total-sum-td-mom" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "变化：", -1))
const _hoisted_31 = {
  key: 0,
  class: "total-empty-mark"
}
const _hoisted_32 = { class: "total-data-group-title total-data-group-title--daily" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "star" }, "*", -1))
const _hoisted_34 = {
  key: 0,
  class: "total-data-group-title__note"
}
const _hoisted_35 = { class: "total-summary-table dim-daily-table" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "total-sum-td-name" }
const _hoisted_38 = { class: "dim-daily-name-wrap" }
const _hoisted_39 = { class: "total-sum-td-value" }
const _hoisted_40 = { class: "high-light" }
const _hoisted_41 = { class: "total-sum-td-mom" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "环比：", -1))
const _hoisted_43 = {
  key: 0,
  class: "total-empty-mark"
}
const _hoisted_44 = { class: "total-sum-td-name col-name--sub" }
const _hoisted_45 = { class: "total-sum-td-value" }
const _hoisted_46 = { class: "high-light" }
const _hoisted_47 = { class: "total-sum-td-mom" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "环比：", -1))
const _hoisted_49 = {
  key: 0,
  class: "total-empty-mark"
}
const _hoisted_50 = { class: "total-data-group-title" }
const _hoisted_51 = { class: "total-data-table" }
const _hoisted_52 = { class: "total-data-row" }
const _hoisted_53 = { class: "col-name" }
const _hoisted_54 = { class: "col-value" }
const _hoisted_55 = { class: "col-mom" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mom-label" }, "环比", -1))
const _hoisted_57 = { class: "col-name col-name--sub" }
const _hoisted_58 = { class: "col-value" }
const _hoisted_59 = { class: "col-mom" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mom-label" }, "环比", -1))
const _hoisted_61 = { class: "space" }
const _hoisted_62 = { class: "vertical-market-dimension-tabs" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "运营商排行榜", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "运营商激活排行", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "运营商激活排行", -1))
const _hoisted_66 = { class: "row vertical-market-table-head" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, /*#__PURE__*/_toDisplayString("运营商名称"), -1))
const _hoisted_68 = { class: "percentage" }
const _hoisted_69 = { class: "rank-list" }
const _hoisted_70 = { class: "percentage" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "渠道排行榜", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "渠道激活排行", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "渠道激活排行", -1))
const _hoisted_74 = { class: "row vertical-market-table-head" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, /*#__PURE__*/_toDisplayString("渠道名称"), -1))
const _hoisted_76 = { class: "percentage" }
const _hoisted_77 = { class: "rank-list" }
const _hoisted_78 = { class: "percentage" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "产品销售排行 TOP 5", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row vertical-market-table-head" }, [
  /*#__PURE__*/_createElementVNode("div", null, "产品名称"),
  /*#__PURE__*/_createElementVNode("div", null, "下单成功量"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "下单成功率")
], -1))
const _hoisted_81 = { class: "rank-list" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "渠道销售排行 TOP 5", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row vertical-market-table-head" }, [
  /*#__PURE__*/_createElementVNode("div", null, "渠道"),
  /*#__PURE__*/_createElementVNode("div", null, "下单成功量"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "下单成功率")
], -1))
const _hoisted_84 = { class: "rank-list" }
const _hoisted_85 = { class: "percentage" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "产品销售排行 TOP 5", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row vertical-market-table-head" }, [
  /*#__PURE__*/_createElementVNode("div", null, "产品名称"),
  /*#__PURE__*/_createElementVNode("div", null, "激活成功量"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "激活成功率")
], -1))
const _hoisted_88 = { class: "rank-list" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "渠道销售排行 TOP 5", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row vertical-market-table-head" }, [
  /*#__PURE__*/_createElementVNode("div", null, "渠道"),
  /*#__PURE__*/_createElementVNode("div", null, "激活成功量"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "激活成功率")
], -1))
const _hoisted_91 = { class: "rank-list" }
const _hoisted_92 = { class: "percentage" }
const _hoisted_93 = {
  key: 0,
  class: "vertical-market-peak-battle"
}

import { ref, watch, onMounted, nextTick, computed } from "vue";
import { useRoute } from "vue-router";
import { Tabs, Tab, Overlay, Loading, Empty, Icon } from "vant";
import { formatPercentage, formatThousands } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";
import VerticalMarket331peakBattle from "@/views/VerticalMarket331peakBattle.vue";

import request from "@/provide/fetch";

/**
 * 全量数据：与接口里每个大分组的 key 完全一致，决定「分几块表」及先后顺序。
 * 留空则按接口 Object.keys 顺序（与改前一致）；填写后按数组顺序分表展示。
 */
interface TotalDataRowItem {
  name: string;
  value?: number | string;
  type?: string;
  percentage?: number | null;
  headValueDataList?: TotalDataRowItem[];
  orderedHeadList?: TotalDataRowItem[];
  [key: string]: unknown;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VerticalMarket',
  setup(__props) {

const TOTAL_DATA_SECTION_ORDER: string[] = [
  "当日数据",
  "当月数据",
  // 其它分组 key 写在后面，或留空两项仅保留其它接口顺序
];

/** 使用「当日/当月」截图布局的分组 key（与接口 res.data 的 key 一致） */
const DAILY_MONTHLY_LAYOUT_KEYS = new Set(["当日数据", "当月数据"]);

/** 摘要区行序：每项为展示用规范名；当日/当月分组内匹配见 resolveRowInDailyMonthlySection */
const SUMMARY_METRICS: string[] = [
  "收单量(不去重)",
  "订单总量",
  // "订单有效比例",
];

const VOLUME_TABLE_ORDER: string[] = [
  "下单成功量",
  "发货成功量",
  "激活成功量",
  "实际激活量",
  "累计充值成功量",
  "首月充值成功量",
];

const RATE_TABLE_ORDER: string[] = [
  "下单成功率",
  "发货成功率",
  "激活成功率",
  // "实际激活成功率",
  "累计充值成功率",
  "首月充值成功率",
];

/** 用于按「逻辑名」对齐接口里的 name：去空白、统一括号、累积/累计；后端「订单比例」「有效比例」等与配置「订单有效比例」对齐 */
function normalizeMetricName(s: string): string {
  let t = s
    .replace(/\s+/g, "")
    .replace(/（/g, "(")
    .replace(/）/g, ")")
    .replace(/累积/g, "累计");
  if (t === "有效比例") {
    return "订单有效比例";
  }
  return t;
}

/** 表格展示：去掉后台名称开头的「当日」「本月」「当月」（仅前缀一次） */
function stripLeadingPeriodLabel(label: string | undefined | null): string {
  if (label == null || label === "") return "";
  const s = String(label).trim();
  if (s.startsWith("当日")) return s.slice(2).trimStart();
  if (s.startsWith("本月")) return s.slice(2).trimStart();
  if (s.startsWith("当月")) return s.slice(2).trimStart();
  return s;
}

/** 当日/当月分组内：去掉与分组对应的前缀后再比「逻辑名」 */
function logicalKeyDailyMonthly(
  sectionKey: string,
  normalizedName: string
): string {
  if (sectionKey === "当日数据" && normalizedName.startsWith("当日")) {
    return normalizedName.slice(2);
  }
  if (sectionKey === "当月数据") {
    if (normalizedName.startsWith("当月")) {
      return normalizedName.slice(2);
    }
    if (normalizedName.startsWith("本月")) {
      return normalizedName.slice(2);
    }
  }
  return normalizedName;
}

function resolveRowInDailyMonthlySection(
  sectionKey: string,
  items: TotalDataRowItem[],
  candidates: string[]
): TotalDataRowItem | null {
  const byExact = new Map(items.map((r) => [r.name, r]));
  for (const c of candidates) {
    const hit = byExact.get(c);
    if (hit) return hit;
  }
  const byNorm = new Map(items.map((r) => [normalizeMetricName(r.name), r]));
  for (const c of candidates) {
    const hit = byNorm.get(normalizeMetricName(c));
    if (hit) return hit;
  }
  const byLogical = new Map<string, TotalDataRowItem>();
  for (const r of items) {
    const lk = logicalKeyDailyMonthly(sectionKey, normalizeMetricName(r.name));
    if (!byLogical.has(lk)) {
      byLogical.set(lk, r);
    }
  }
  for (const c of candidates) {
    const lk = logicalKeyDailyMonthly(sectionKey, normalizeMetricName(c));
    const hit = byLogical.get(lk);
    if (hit) return hit;
  }
  return null;
}

function placeholderRow(primaryName: string): TotalDataRowItem {
  return {
    name: primaryName,
    value: "—",
    type: "normal",
    percentage: null,
  };
}

/** 摘要第三行「订单有效比例」：仅一个数值，占两格（与两列表头对齐） */
function isSummaryRatioOnlyRow(row: TotalDataRowItem): boolean {
  return (
    normalizeMetricName(stripLeadingPeriodLabel(row.name)) ===
    normalizeMetricName("订单有效比例")
  );
}

/** 主数值列展示占位「—」时（含接口/占位行里的字面「—」）；百分比主列走 format，不归为占位 */
function isMissingPrimaryValue(row: {
  value?: number | string | null;
  type?: string;
}): boolean {
  if (row.type === "percentage") {
    return false;
  }
  const v = row.value;
  if (v == null || v === "") {
    return true;
  }
  if (typeof v === "string" && v.replace(/\s/g, "") === "—") {
    return true;
  }
  return false;
}

/** 表格主数值：百分比走 formatPercentage，其余千分位；空值「—」 */
function formatMetricValue(row: {
  value?: number | string | null;
  type?: string;
}): string {
  if (isMissingPrimaryValue(row)) return "—";
  if (row.type === "percentage") {
    return formatPercentage(Number(row.value ?? 0));
  }
  return formatThousands(row.value as number | string);
}

function buildDailyMonthlySection(key: string, items: TotalDataRowItem[]) {
  const summaryRows = SUMMARY_METRICS.map((canonical) => {
    const hit = resolveRowInDailyMonthlySection(key, items, [canonical]);
    const base = hit ?? placeholderRow(canonical);
    return { ...base, name: canonical };
  });
  const volumeRows = VOLUME_TABLE_ORDER.map((name) => {
    const hit = resolveRowInDailyMonthlySection(key, items, [name]);
    const base = hit ?? placeholderRow(name);
    return { ...base, name };
  });
  const rateRows = RATE_TABLE_ORDER.map((name) => {
    const hit = resolveRowInDailyMonthlySection(key, items, [name]);
    const base = hit ?? placeholderRow(name);
    return { ...base, name };
  });
  return {
    key,
    title: key,
    titleNote: key === "当月数据" ? "（当月1日 至 昨日）" : undefined,
    layout: "daily-monthly" as const,
    summaryRows,
    volumeRows,
    rateRows,
  };
}

/** 全量数据表格行（接口字段 + 排序用 orderedHeadList） */
function pickOrderedSectionKeys(
  raw: Record<string, unknown>,
  order: string[]
): string[] {
  const keys = Object.keys(raw);
  if (!order.length) return keys;
  const seen = new Set<string>();
  const out: string[] = [];
  for (const k of order) {
    if (keys.includes(k)) {
      out.push(k);
      seen.add(k);
    }
  }
  for (const k of keys) {
    if (!seen.has(k)) out.push(k);
  }
  return out;
}

function orderHeadChildren(item: TotalDataRowItem): TotalDataRowItem[] {
  const list = item.headValueDataList;
  return Array.isArray(list) && list.length > 0 ? list : [];
}

/** 运营商 / 渠道维度：当日、当月分组原始行（可折叠面板数据源） */
function rawGroupItems(sectionKey: string): TotalDataRowItem[] {
  const raw = pageData.value as Record<string, unknown>;
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return [];
  const g = raw[sectionKey];
  return Array.isArray(g) ? (g as TotalDataRowItem[]) : [];
}

function dimDailyRowKey(sectionKey: string, itemIndex: number): string {
  return `${sectionKey}#${itemIndex}`;
}

/** 运营商 / 渠道：当日、当月手风琴展开（单表内，不用 Vant Collapse） */
const expandedDimDailyRows = ref<Record<string, boolean>>({});

function isDimDailyRowExpanded(sectionKey: string, itemIndex: number) {
  return !!expandedDimDailyRows.value[dimDailyRowKey(sectionKey, itemIndex)];
}

function toggleDimDailyRow(key: string) {
  expandedDimDailyRows.value = {
    ...expandedDimDailyRows.value,
    [key]: !expandedDimDailyRows.value[key],
  };
}

function onDimDailyParentClick(
  sectionKey: string,
  itemIndex: number,
  item: TotalDataRowItem
) {
  const list = item.headValueDataList;
  if (!Array.isArray(list) || list.length === 0) return;
  toggleDimDailyRow(dimDailyRowKey(sectionKey, itemIndex));
}

const totalDataSections = computed(() => {
  const raw = pageData.value as Record<string, unknown>;
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return [];
  const sectionKeys = pickOrderedSectionKeys(raw, TOTAL_DATA_SECTION_ORDER);
  return sectionKeys.map((key) => {
    const group = raw[key];
    const items = (Array.isArray(group) ? group : []) as TotalDataRowItem[];
    if (DAILY_MONTHLY_LAYOUT_KEYS.has(key)) {
      return buildDailyMonthlySection(key, items);
    }
    return {
      key,
      title: key,
      layout: "flat" as const,
      rows: items.map((item) => ({
        ...item,
        orderedHeadList: orderHeadChildren(item),
      })),
    };
  });
});

const route = useRoute();
const active = ref(0);
const field = ref("orderSuccessCount");

const visible = ref(true);
const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/cs/channel-total",
    method: "POST",
    data: {
      startDay: route?.params.time,
      endDay: route?.params.time,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    pageData.value = res.data;
    visible.value = true;
  }
};
getPageData();
let time = dayjs(route.params.time as string).format("YYYY-MM-DD");

/** 战队维度为独立权限：list-battle-group-detail 返回 401 仅隐藏 Tab，不跳转无权限页 */
const hasPeakBattleTab = ref(false);
const checkPeakBattlePermission = async () => {
  const res = await request({
    url: "/api/wx/cs/list-battle-group-detail",
    method: "POST",
    data: { startDay: time, endDay: time },
    headers: { openId: sessionStorage.getItem("openid") },
    skipAuthRedirect: true,
  });
  hasPeakBattleTab.value = res?.code === 200;
};
checkPeakBattlePermission();
// 产品排行
const productsList = ref<any>([]);
const getProductsData = async () => {
  const res = await request({
    url: "/api/wx/cs/page-channel-product",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 5,
      },
      searchOption: {
        startDay: time,
        endDay: time,
        orderItem: {
          field: field.value,
          asc: false,
        },
        groupUnit: "product",
        pidList: null,
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    productsList.value = res.data.records;
  }
};
getProductsData();

// 运营商 / 渠道维度排行（list-operator-detail / list-channel-detail）
const distributorList = ref<any>([]);
/** 全量数据下方「渠道销售排行 TOP5」专用，与 distributorList 分离，避免切 Tab 时被覆盖 */
const channelTop5List = ref<any[]>([]);
const getDistributorList = async () => {
  const res = await request({
    url: "/api/wx/cs/page-channel-product",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 5,
      },
      searchOption: {
        startDay: time,
        endDay: time,
        orderItem: {
          field: field.value,
          asc: false,
        },
        groupUnit: "platform",
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    channelTop5List.value = res.data.records;
  }
};
getDistributorList();

const handleChange = (name: number) => {
  if (name === 1) {
    field.value = "activeCount";
  } else {
    field.value = "orderSuccessCount";
  }
  getProductsData();
  getDistributorList();
};

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
const applyPageWatermark = () => {
  const name = sessionStorage.getItem("name");
  if (!name) return;
  nextTick(() => {
    createWatermark(name, "page-watermark-host");
  });
};

onMounted(() => {
  if (sessionStorage.getItem("name")) {
    applyPageWatermark();
  } else {
    getUserInfo().then(() => applyPageWatermark());
  }
});

const tabs = ref();
watch(visible, (show) => {
  if (show) {
    applyPageWatermark();
  }
  nextTick(() => {
    tabs.value?.resize?.();
  });
});
const group = ref();
const GetOtherPageData = async () => {
  const res = await request({
    url: "/api/wx/cs/operator-total",
    method: "POST",
    data: {
      startDay: route?.params.time,
      endDay: route?.params.time,
      group: group.value,
      orderItem: {
        asc: false,
        field: field.value,
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    pageData.value = res.data;
    visible.value = true;
  }
};

const GetChannelPageData = async () => {
  const res = await request({
    url: "/api/wx/cs/channel-statistics",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      group: group.value,
      orderItem: {
        asc: false,
        field: field.value,
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    pageData.value = res.data;
    visible.value = true;
  }
};

const activeTotal = ref(0);
const handleChangeTotal = (value: number) => {
  if (value < 3) {
    expandedDimDailyRows.value = {};
  }
  if (value === 0) {
    active.value = 0;
    getPageData();
    getProductsData();
    getDistributorList();
    group.value = "";
  } else if (value === 1) {
    active.value = 1;
    group.value = "operator";
    GetOtherPageData();
    active.value = 0;
    getNewDistributorList();
  } else if (value === 2) {
    active.value = 2;
    group.value = "channel";
    GetChannelPageData();
    getChannelRankList();
  } else if (value === 3) {
    group.value = "";
  }
};
watch(hasPeakBattleTab, (ok) => {
  if (!ok && activeTotal.value === 3) {
    activeTotal.value = 0;
    handleChangeTotal(0);
  } else if (ok) {
    nextTick(() => tabs.value?.resize?.());
  }
});
const getChannelRankList = async () => {
  const res = await request({
    url: "/api/wx/cs/list-channel-detail",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      group: group.value,
      groupUnit: channelActive.value == 2 ? "month" : "",
      orderItem: {
        asc: false,
        field:
          channelActive.value == 0 ? "orderSuccessCount" : "actualActiveCount",
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    distributorList.value = res.data;
  }
};
const getNewDistributorList = async () => {
  const res = await request({
    url: "/api/wx/cs/list-operator-detail",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      group: group.value,
      groupUnit: operatorActive.value == 2 ? "month" : "",
      orderItem: {
        asc: false,
        field:
          operatorActive.value == 0 ? "orderSuccessCount" : "actualActiveCount",
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    distributorList.value = res.data;
  }
};
const operatorActive = ref(0);
const channelActive = ref(0);
const handleChangeOperator = () => {
  getNewDistributorList();
};
const handleChangeChannel = () => {
  getChannelRankList();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "日报时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Tabs), {
            active: activeTotal.value,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((activeTotal).value = $event)),
            onChange: handleChangeTotal,
            ref_key: "tabs",
            ref: tabs
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Tab), { title: "全量数据" }),
              _createVNode(_unref(Tab), { title: "运营商维度" }),
              _createVNode(_unref(Tab), { title: "渠道维度" }),
              (hasPeakBattleTab.value)
                ? (_openBlock(), _createBlock(_unref(Tab), {
                    key: 0,
                    title: "战队维度"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["active"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(totalDataSections), (section) => {
            return (_openBlock(), _createElementBlock("div", {
              key: section.key,
              class: "total-data-group"
            }, [
              (section.layout === 'daily-monthly' && activeTotal.value === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", _hoisted_7, [
                      _hoisted_8,
                      _createTextVNode(_toDisplayString(section.title), 1),
                      (section.titleNote)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(section.titleNote), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("table", _hoisted_10, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.summaryRows, (row, si) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: 's' + si
                          }, [
                            (isSummaryRatioOnlyRow(row))
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                  _createElementVNode("td", _hoisted_12, _toDisplayString(stripLeadingPeriodLabel(row.name)), 1),
                                  _createElementVNode("td", _hoisted_13, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["high-light", {
                            'total-empty-mark':
                              row.type !== 'percentage' &&
                              isMissingPrimaryValue(row),
                          }])
                                    }, _toDisplayString(formatMetricValue(row)), 3)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                                  _createElementVNode("td", _hoisted_15, _toDisplayString(stripLeadingPeriodLabel(row.name)), 1),
                                  _createElementVNode("td", _hoisted_16, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["high-light", {
                            'total-empty-mark': isMissingPrimaryValue(row),
                          }])
                                    }, _toDisplayString(formatMetricValue(row)), 3)
                                  ]),
                                  _createElementVNode("td", _hoisted_17, [
                                    _hoisted_18,
                                    (row.percentage == null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "—"))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          style: _normalizeStyle({
                            color: (row.percentage ?? 0) >= 0 ? 'red' : 'green',
                          })
                                        }, _toDisplayString(`${
                              (row.percentage ?? 0) >= 0 ? "+" : ""
                            }${_unref(formatPercentage)(Number(row.percentage ?? 0))}`), 5))
                                  ])
                                ]))
                          ], 64))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_20, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.volumeRows, (row, vi) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: 'v' + vi
                          }, [
                            _createElementVNode("td", _hoisted_21, _toDisplayString(stripLeadingPeriodLabel(row.name)), 1),
                            _createElementVNode("td", _hoisted_22, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["high-light", {
                          'total-empty-mark': isMissingPrimaryValue(row),
                        }])
                              }, _toDisplayString(formatMetricValue(row)), 3)
                            ]),
                            _createElementVNode("td", _hoisted_23, [
                              _hoisted_24,
                              (row.percentage == null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "—"))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    style: _normalizeStyle({
                          color: (row.percentage ?? 0) >= 0 ? 'red' : 'green',
                        })
                                  }, _toDisplayString(`${
                            (row.percentage ?? 0) >= 0 ? "+" : ""
                          }${_unref(formatPercentage)(Number(row.percentage ?? 0))}`), 5))
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_26, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.rateRows, (row, ri) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: 'r' + ri
                          }, [
                            _createElementVNode("td", _hoisted_27, _toDisplayString(stripLeadingPeriodLabel(row.name)), 1),
                            _createElementVNode("td", _hoisted_28, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["high-light", {
                          'total-empty-mark': isMissingPrimaryValue(row),
                        }])
                              }, _toDisplayString(formatMetricValue(row)), 3)
                            ]),
                            _createElementVNode("td", _hoisted_29, [
                              _hoisted_30,
                              (row.percentage == null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "—"))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    style: _normalizeStyle({
                          color: (row.percentage ?? 0) >= 0 ? 'red' : 'green',
                        })
                                  }, _toDisplayString(`${
                            (row.percentage ?? 0) >= 0 ? "+" : ""
                          }${_unref(formatPercentage)(Number(row.percentage ?? 0))}`), 5))
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ], 64))
                : (section.layout === 'daily-monthly' && activeTotal.value > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("p", _hoisted_32, [
                        _hoisted_33,
                        _createTextVNode(_toDisplayString(section.title), 1),
                        (section.titleNote)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(section.titleNote), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("table", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rawGroupItems(section.key), (item, itemIndex) => {
                          return (_openBlock(), _createElementBlock("tbody", {
                            key: section.key + '-' + itemIndex
                          }, [
                            _createElementVNode("tr", {
                              class: _normalizeClass(["dim-daily-parent-row", {
                      'dim-daily-parent-row--expandable':
                        item.headValueDataList &&
                        item.headValueDataList.length > 0,
                    }]),
                              onClick: ($event: any) => (onDimDailyParentClick(section.key, itemIndex, item))
                            }, [
                              _createElementVNode("td", _hoisted_37, [
                                _createElementVNode("span", _hoisted_38, [
                                  _createTextVNode(_toDisplayString(stripLeadingPeriodLabel(item.name)) + " ", 1),
                                  (
                            item.headValueDataList &&
                            item.headValueDataList.length > 0
                          )
                                    ? (_openBlock(), _createBlock(_unref(Icon), {
                                        key: 0,
                                        name: "arrow-down",
                                        class: _normalizeClass(["dim-daily-chevron", {
                            'dim-daily-chevron--open': isDimDailyRowExpanded(
                              section.key,
                              itemIndex
                            ),
                          }])
                                      }, null, 8, ["class"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_39, [
                                _createElementVNode("span", _hoisted_40, _toDisplayString(formatMetricValue(item)), 1)
                              ]),
                              _createElementVNode("td", _hoisted_41, [
                                _hoisted_42,
                                (item.percentage == null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, "—"))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      style: _normalizeStyle({
                          color: (item.percentage ?? 0) >= 0 ? 'red' : 'green',
                        })
                                    }, _toDisplayString(`${
                            (item.percentage ?? 0) >= 0 ? "+" : ""
                          }${_unref(formatPercentage)(Number(item.percentage ?? 0))}`), 5))
                              ])
                            ], 10, _hoisted_36),
                            (
                      isDimDailyRowExpanded(section.key, itemIndex) &&
                      item.headValueDataList &&
                      item.headValueDataList.length > 0
                    )
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.headValueDataList, (thirdLevelItem, thirdLevelIndex) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: 'sub-' + thirdLevelIndex,
                                    class: "dim-daily-sub-row"
                                  }, [
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(stripLeadingPeriodLabel(thirdLevelItem.name)), 1),
                                    _createElementVNode("td", _hoisted_45, [
                                      _createElementVNode("span", _hoisted_46, _toDisplayString(formatMetricValue(thirdLevelItem)), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_47, [
                                      _hoisted_48,
                                      (thirdLevelItem.percentage == null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, "—"))
                                        : (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            style: _normalizeStyle({
                            color:
                              (thirdLevelItem.percentage ?? 0) >= 0
                                ? 'red'
                                : 'green',
                          })
                                          }, _toDisplayString(`${
                              (thirdLevelItem.percentage ?? 0) >= 0 ? "+" : ""
                            }${_unref(formatPercentage)(
                              Number(thirdLevelItem.percentage ?? 0)
                            )}`), 5))
                                    ])
                                  ]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("p", _hoisted_50, "·" + _toDisplayString(section.title), 1),
                      _createElementVNode("table", _hoisted_51, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.rows, (item, itemIndex) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: itemIndex }, [
                              _createElementVNode("tr", _hoisted_52, [
                                _createElementVNode("td", _hoisted_53, _toDisplayString(stripLeadingPeriodLabel(item.name)), 1),
                                _createElementVNode("td", _hoisted_54, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["high-light", {
                            'total-empty-mark': isMissingPrimaryValue(item),
                          }])
                                  }, _toDisplayString(formatMetricValue(item)), 3)
                                ]),
                                _createElementVNode("td", _hoisted_55, [
                                  _hoisted_56,
                                  _createElementVNode("span", {
                                    style: _normalizeStyle({
                            color:
                              (item.percentage ?? 0) >= 0 ? 'red' : 'green',
                          })
                                  }, _toDisplayString(`${
                              (item.percentage ?? 0) >= 0 ? "+" : ""
                            }${_unref(formatPercentage)(Number(item.percentage ?? 0))}`), 5)
                                ])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.orderedHeadList || [], (thirdLevelItem, thirdLevelIndex) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: `${itemIndex}-${thirdLevelIndex}`,
                                  class: "total-data-row total-data-row--sub"
                                }, [
                                  _createElementVNode("td", _hoisted_57, _toDisplayString(stripLeadingPeriodLabel(thirdLevelItem.name)), 1),
                                  _createElementVNode("td", _hoisted_58, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["high-light", {
                            'total-empty-mark':
                              isMissingPrimaryValue(thirdLevelItem),
                          }])
                                    }, _toDisplayString(formatMetricValue(thirdLevelItem)), 3)
                                  ]),
                                  _createElementVNode("td", _hoisted_59, [
                                    _hoisted_60,
                                    _createElementVNode("span", {
                                      style: _normalizeStyle({
                            color:
                              (thirdLevelItem.percentage ?? 0) >= 0
                                ? 'red'
                                : 'green',
                          })
                                    }, _toDisplayString(`${
                              (thirdLevelItem.percentage ?? 0) >= 0 ? "+" : ""
                            }${_unref(formatPercentage)(
                              Number(thirdLevelItem.percentage ?? 0)
                            )}`), 5)
                                  ])
                                ]))
                              }), 128))
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ], 64))
            ]))
          }), 128))
        ], 512), [
          [_vShow, activeTotal.value < 3]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_61, null, 512), [
          [_vShow, activeTotal.value < 3]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_62, [
          (group.value === 'operator')
            ? (_openBlock(), _createBlock(_unref(Tabs), {
                key: 0,
                active: operatorActive.value,
                "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((operatorActive).value = $event)),
                onChange: handleChangeOperator,
                ref_key: "tabs",
                ref: tabs
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Tab), { title: "当天下单成功维度" }, {
                    default: _withCtx(() => [
                      _hoisted_63
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Tab), { title: "当天实际激活维度" }, {
                    default: _withCtx(() => [
                      _hoisted_64
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Tab), { title: "本月实际激活维度" }, {
                    default: _withCtx(() => [
                      _hoisted_65
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("div", null, _toDisplayString(operatorActive.value == 0
                    ? "下单成功量"
                    : operatorActive.value == 1
                    ? "当天实际激活量"
                    : "本月实际激活量"), 1),
                    _createElementVNode("div", _hoisted_68, _toDisplayString(operatorActive.value == 0
                    ? "下单成功率"
                    : operatorActive.value == 1
                    ? "当天实际激活率"
                    : "本月实际激活率"), 1)
                  ]),
                  (!distributorList.value.length)
                    ? (_openBlock(), _createBlock(_unref(Empty), {
                        key: 0,
                        description: "暂无数据",
                        "image-size": "100"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_69, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributorList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row",
                        style: { borderBottom: '1px solid #ebedf0' },
                        key: index
                      }, [
                        _createElementVNode("div", null, _toDisplayString(item.operator), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(formatThousands)(
                      operatorActive.value == 0
                        ? item.orderSuccessCount
                        : item.actualActiveCount
                    )), 1),
                        _createElementVNode("div", _hoisted_70, _toDisplayString(operatorActive.value == 0
                      ? item.orderSuccessRate
                      : item.actualActiveRate), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["active"]))
            : _createCommentVNode("", true),
          (group.value === 'channel')
            ? (_openBlock(), _createBlock(_unref(Tabs), {
                key: 1,
                active: channelActive.value,
                "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((channelActive).value = $event)),
                onChange: handleChangeChannel,
                ref_key: "tabs",
                ref: tabs
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Tab), { title: "当天下单成功维度" }, {
                    default: _withCtx(() => [
                      _hoisted_71
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Tab), { title: "当天实际激活维度" }, {
                    default: _withCtx(() => [
                      _hoisted_72
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Tab), { title: "本月实际激活维度" }, {
                    default: _withCtx(() => [
                      _hoisted_73
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("div", null, _toDisplayString(channelActive.value == 0
                    ? "下单成功量"
                    : channelActive.value == 1
                    ? "当天实际激活量"
                    : "本月实际激活量"), 1),
                    _createElementVNode("div", _hoisted_76, _toDisplayString(channelActive.value == 0
                    ? "下单成功率"
                    : channelActive.value == 1
                    ? "当天实际激活率"
                    : "本月实际激活率"), 1)
                  ]),
                  (!distributorList.value.length)
                    ? (_openBlock(), _createBlock(_unref(Empty), {
                        key: 0,
                        description: "暂无数据",
                        "image-size": "100"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_77, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributorList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row",
                        style: { borderBottom: '1px solid #ebedf0' },
                        key: index
                      }, [
                        _createElementVNode("div", null, _toDisplayString(item.platformName + "-" + item.channelName), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(formatThousands)(
                      channelActive.value == 0
                        ? item.orderSuccessCount
                        : item.actualActiveCount
                    )), 1),
                        _createElementVNode("div", _hoisted_78, _toDisplayString(channelActive.value == 0
                      ? item.orderSuccessRate
                      : item.actualActiveRate), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["active"]))
            : _createCommentVNode("", true),
          (activeTotal.value < 3)
            ? (_openBlock(), _createBlock(_unref(Tabs), {
                key: 2,
                active: active.value,
                "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((active).value = $event)),
                onChange: handleChange,
                ref_key: "tabs",
                ref: tabs
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Tab), { title: "下单成功纬度" }, {
                    default: _withCtx(() => [
                      _hoisted_79,
                      _hoisted_80,
                      (!productsList.value.length)
                        ? (_openBlock(), _createBlock(_unref(Empty), {
                            key: 0,
                            description: "暂无数据",
                            "image-size": "100"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_81, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row",
                            style: { borderBottom: '1px solid #ebedf0' },
                            key: index
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.productName || "- -"), 1),
                            _createElementVNode("div", null, _toDisplayString(_unref(formatThousands)(item.orderSuccessCount)), 1),
                            _createElementVNode("div", null, _toDisplayString(item.orderSuccessRate), 1)
                          ]))
                        }), 128))
                      ]),
                      _hoisted_82,
                      _hoisted_83,
                      (!channelTop5List.value.length)
                        ? (_openBlock(), _createBlock(_unref(Empty), {
                            key: 1,
                            description: "暂无数据",
                            "image-size": "100"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_84, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelTop5List.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row",
                            style: { borderBottom: '1px solid #ebedf0' },
                            key: index
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.platformName), 1),
                            _createElementVNode("div", null, _toDisplayString(_unref(formatThousands)(item.orderSuccessCount)), 1),
                            _createElementVNode("div", _hoisted_85, _toDisplayString(item.orderSuccessRate), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Tab), { title: "激活成功纬度" }, {
                    default: _withCtx(() => [
                      _hoisted_86,
                      _hoisted_87,
                      (!productsList.value.length)
                        ? (_openBlock(), _createBlock(_unref(Empty), {
                            key: 0,
                            description: "暂无数据",
                            "image-size": "100"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_88, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row",
                            style: { borderBottom: '1px solid #ebedf0' },
                            key: index
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.productName || "- -"), 1),
                            _createElementVNode("div", null, _toDisplayString(_unref(formatThousands)(item.activeCount)), 1),
                            _createElementVNode("div", null, _toDisplayString(item.activeRate), 1)
                          ]))
                        }), 128))
                      ]),
                      _hoisted_89,
                      _hoisted_90,
                      (!channelTop5List.value.length)
                        ? (_openBlock(), _createBlock(_unref(Empty), {
                            key: 1,
                            description: "暂无数据",
                            "image-size": "100"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_91, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelTop5List.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row",
                            style: { borderBottom: '1px solid #ebedf0' },
                            key: index
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.platformName), 1),
                            _createElementVNode("div", null, _toDisplayString(_unref(formatThousands)(item.activeCount)), 1),
                            _createElementVNode("div", _hoisted_92, _toDisplayString(item.activeRate), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["active"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, activeTotal.value < 3]
        ]),
        (hasPeakBattleTab.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_93, [
              _createVNode(VerticalMarket331peakBattle, { embedded: true })
            ], 512)), [
              [_vShow, activeTotal.value === 3]
            ])
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})